<template>
  <div>
    <el-breadcrumb separator="/" style="margin-bottom: 20px;">
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project/batch' }">项目奖申报批次</el-breadcrumb-item>
      <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/project?batchId=' +  $route.query.batchId }">项目奖申报</el-breadcrumb-item>
      <el-breadcrumb-item>补充材料</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card v-loading="loadings">
      <el-form :model="addForm" :rules="ruleAddForm" ref="addForm" label-position="top" label-width="120px" class="demo-ruleForm" style="padding: 0 20px; box-sizing: border-box;">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="答辩单位" prop="replyUnit" :rules="{ required: true, message: '请输入答辩单位', trigger: 'blur' }">
              <el-input size="small" maxlength="50" show-word-limit v-model.trim="addForm.replyUnit" placeholder="请输入答辩单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="答辩项目" prop="replyName" :rules="{ required: true, message: '请输入答辩项目', trigger: 'blur' }">
              <el-input size="small" maxlength="50" show-word-limit v-model.trim="addForm.replyName" placeholder="请输入答辩项目"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-for="(item, index) in addForm.list" :key="index" >
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
              :label="index == 0 ? '主答辩人': '答辩人'"
              :prop="'list.' + index + '.name'"
              :rules="{ required: true, message: '请输入答辩人姓名', trigger: 'blur' }">
                <el-input size="small" maxlength="50" show-word-limit v-model.trim="item.name" placeholder="请输入答辩人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
              label="职务"
              :prop="'list.' + index + '.post'"
              :rules="{ required: true, message: '请输入答辩人职务', trigger: 'blur' }">
                <el-input size="small" maxlength="20" show-word-limit v-model.trim="item.post" placeholder="请输入答辩人职务"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
              label="电话"
              :prop="'list.' + index + '.phone'"
              :rules="[{ required: true, message: '请输入答辩人电话', trigger: 'blur' }, { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误', trigger: ['blur', 'change'] }]">
                <el-input size="small" maxlength="11" show-word-limit v-model.trim="item.phone" placeholder="请输入答辩人电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="" prop="projectExcelPath" class="db-lable-b">
              <span slot="label">
                <span>项目答辩PPT（限PPT格式 100MB）</span>
              </span>
              <el-checkbox-group v-model="addForm.projectExcelPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="100" :accept="'.ppt,.pptx'" @UploadFileFun="UploadFileFun($event, 'projectExcelPath')" :callbackShow="addForm.projectExcelFiles"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目介绍的简本（包含项目背景、主要技术路线、创新点、社会经济效益等内容，不超过20页 100MB）" prop="declarePdfPath"
              class="db-lable-b">
              <el-checkbox-group v-model="addForm.declarePdfPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :size="100" @UploadFileFun="UploadFileFun($event, 'declarePdfPath')"
                :callbackShow="addForm.declarePdfFiles"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="" prop="projectResultsPath" class="db-lable-b">
              <span slot="label">
                <span>终审答辩人员信息表（限excel文件）</span>
                <el-link type="primary" :underline="false" style="margin-top: -4px;" @click="download(7)">下载模板</el-link>
              </span>
              <el-checkbox-group v-model="addForm.projectResultsPath" v-show="false"></el-checkbox-group>
              <My-Upload-Filebutton :limit="1" :accept="'.xls,.xlsx'"
                @UploadFileFun="UploadFileFun($event, 'projectResultsPath')"
                :callbackShow="addForm.projectResultsFiles"></My-Upload-Filebutton>
            </el-form-item>
          </el-col>
        </el-row> -->
        <div style="text-align: center; margin: 50px 0 20px;" v-if="status == 1">
          <!-- <el-button>取消</el-button> -->
          <el-button type="primary" @click="submit" :loading="loading">提 交</el-button>
        </div>
        <!--  -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { projectMaterialReportZS, getStProjectAward, getProjectAwardBatchList } from '@/api/admin'
import { systemRespondent } from '@/api/system'
import MyUploadFilebutton from '@/components/uploadFilebutton/UploadFilebutton'

export default {
  components: { MyUploadFilebutton },
  data () {
    return {
      loading: false,
      loadings: false,
      status: '',
      addForm: {
        replyUnit: '',
        replyName: '',
        list: [
          { name: '', post: '', phone: '' },
          { name: '', post: '', phone: '' },
          { name: '', post: '', phone: '' }
        ],
        opinion: '',
        id: '',
        projectExcelPath: '',
        declarePdfPath: '',
        projectResultsPath: ''
      },
      ruleAddForm: {
        projectExcelPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        declarePdfPath: [{ required: true, message: '请上传文件', trigger: 'change' }],
        projectResultsPath: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  created () {
    if (!this.$route.query.batchId || !this.$route.query.id || !this.$route.query.projectId) {
      this.$router.push({ path: '/project/batch' })
      return false
    }
    getProjectAwardBatchList({ page: 1, pageSize: 500 }).then(res => {
      if (res.code == '000') {
        const batchIds = res.result.records
        const exists = batchIds.some(item => item.id === this.$route.query.batchId)
        if (!exists) {
          this.$router.push({ path: '/project/batch' })
        } else {
          batchIds.forEach(item => {
            if (item.id == this.$route.query.batchId) {
              this.status = item.status
            }
          })
        }
      }
    })
  },
  methods: {
    submit() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return this.$message.error('您还有必填项没有填写，请填写完成后再提交')
        this.$confirm('是否确定提交补充材料?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            reply: {
              replyUnit: this.addForm.replyUnit,
              replyName: this.addForm.replyName,
              replyPerson1: this.addForm.list[0].name,
              replyPerson2: this.addForm.list[1].name,
              replyPerson3: this.addForm.list[2].name,
              job1: this.addForm.list[0].post,
              job2: this.addForm.list[1].post,
              job3: this.addForm.list[2].post,
              phone1: this.addForm.list[0].phone,
              phone2: this.addForm.list[1].phone,
              phone3: this.addForm.list[2].phone
            },
            reportPo: {
              phase: 3,
              projectId: this.$route.query.projectId,
              projectAwardId: this.$route.query.id,
              fileItems: [
                { type: 1, filePath: this.addForm.projectExcelPath, sort: 1 },
                { type: 2, filePath: this.addForm.declarePdfPath, sort: 2 }
              ]
            }
          }
          this.loading = true
          projectMaterialReportZS(params).then(res => {
            this.loading = false
            if (res.code == '000') {
              this.$message.success('操作成功')
              setTimeout(() => {
                this.$router.replace({ path: '/project', query: { batchId: this.$route.query.batchId } })
              }, 500)
            }
          })
        })
      })
    },
    dtl (id) {
      this.loadings = true
      getStProjectAward({ id }).then(res => {
        this.loadings = false
        if (res.code === '000') {
          this.addForm.opinion = res.result.opinion
          this.addForm.projectName = res.result.projectName
          this.addForm.category = res.result.category
          // this.addForm.projectExcelFiles = res.result.projectExcelFiles
          // this.addForm.declarePdfFiles = res.result.declarePdfFiles
          // this.addForm.projectResultsFiles = res.result.projectResultsFiles
          // res.result.declareWordPath = ''
          // res.result.policyProvePath = ''
          // res.result.applyProvePath = ''
          // res.result.intellectualPropertyPath = ''
          // res.result.sciTechNoveltyPath = ''
          // res.result.reportPath = ''
          // res.result.applicationPath = ''
          // if (res.result.isOwnPatent != 1) {
          //   res.result.stProjectPatents = [{ patentName: '', patentNumber: '' }]
          // }
          // this.addForm = res.result
        }
      })
    },
    UploadFileFun(e, type) {
      this.addForm[type] = e
    },
    download(status) {
      systemRespondent({}).then(res => {
        const blob = new Blob([res.data])
        const fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('filename=')[1])
        // const fileName = name
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
}
</script>

<style lang="less" >
  .el-form--label-top .el-form-item__content {
    line-height: 32px;
  }
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 32px;
  }
  .el-form--label-top .el-form-item {
    margin-bottom: 14px;
  }
</style>
